<template>
  <div class="robbing">
    <nav class="robbing-nav">
      <div class="robbing-nav-item" @click="toggleType('time')">按时间</div>
      <div class="robbing-nav-item" @click="toggleType('fee')">按赏金</div>
      <div class="robbing-nav-item" @click="gotoRobbinged">已抢单</div>
      <div class="robbing-nav-item select" v-if="userInfo.isPaotuiLeader">设置楼长</div>
    </nav>

    <section class="mail-tips">
      点击查看
      <a
        href="javascript:;"
        style="color: blue; text-decoration:underline;"
        @click="paotuiStatusInfo"
      >跑腿接单状况 >></a>
    </section>
    <div class="item" v-for="item in list" :key="item.exName">
      <div style="text-align: center;">
        <div class="express-company">
          {{item.name}}
          <span class="express-count">({{item.tag}})</span>
        </div>
        <div class="img-container">
          <img
            class="img"
            :src="item.manager?'data:image/png;base64,'+item.manager.headimgBase64:defaultHeader"
          />
        </div>
      </div>
      <div class="weui-cells">
        <div class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>
              <i class="iconfont icon-bussinesscard"></i>
              {{item.manager?item.manager.realname:"待指定"}}
            </p>
          </div>
          <div class="weui-cell__hd">{{item.manager?item.manager.phoneMain:"--"}}</div>
          <div class="weui-cell__hd delete-bnt" v-if="item.manager" @click="delMaster(item)">删 除</div>
        </div>
      </div>
      <div>
        <div class="weui-cells__title">根据绑定的主手机号查找</div>
        <div class="weui-cells weui-cells_form">
          <div class="weui-cell weui-cell_vcode">
            <div class="weui-cell__hd">
              <label class="weui-label">手机号</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="tel"
                v-model="item.queryPhone"
                oninput="if(value.length>11)value=value.slice(0,11)"
                placeholder="请输入手机号"
                style="text-align: right;"
              />
            </div>
            <div class="weui-cell__ft">
              <button class="weui-vcode-btn" @click="check(item)">精确查找</button>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>姓名</p>
            </div>
            <div class="weui-cell__ft">{{item.tempManagerName?item.tempManagerName:'--'}}</div>
          </div>
        </div>

        <div class="warehousing-footer-item" style="flex:2" @click="set(item)">
          <a href="javascript:;">设为楼长</a>
        </div>
      </div>
    </div>

    <div class="weui-footer" v-if="!haveData">
      <p class="weui-footer__links">
        <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
      </p>
      <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
    </div>
  </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";
import moment from "moment";
import config from "../../config/config.js";

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      userInfo: {
        isPaotuiLeader: false
      },
      year: moment().format("YYYY"),
      haveData: true,
      list: [],
      phone: "",
      defaultHeader: config.defaultImgBase64
    };
  },
  created() {
    let loading = weui.loading("数据加载中", {
      className: "custom-classname"
    });
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then(response => {
        if (response.data.success) {
          this.userInfo = response.data.data;

          axios
            .get(
              "/api/building/listForSetManager/" + this.userInfo.worksite._id
            )
            .then(res => {
              loading.hide(function() {});
              if (res.data.success) {
                this.list = res.data.data;
              } else {
                this.haveData = false;
                weui.alert(res.data.message);
              }
            })
            .catch(err => {
              this.haveData = false;
              loading.hide(function() {});
              weui.alert("获取大楼列表失败");
            });
        } else {
          weui.alert(response.data.message);
        }
      })
      .catch(err => {
        weui.alert("获取用户信息失败");
      });
  },
  methods: {
    toggleType(status) {
      this.$router.push("/robbing/" + this.encodeToken);
    },
    gotoRobbinged() {
      this.$router.push("/robbingList/2/ing/" + this.encodeToken);
    },
    paotuiStatusInfo() {
      this.$router.push("/paotuiStatusInfo/" + this.encodeToken);
    },
    check(item) {
      if (!item.queryPhone || item.queryPhone.length != 11) {
        weui.alert("请输入正确的手机号码");
        return;
      } else {
        let loading = weui.loading("查询中", {
          className: "custom-classname"
        });
        // 根据token查找微信用户信息
        axios
          .get("/api/user/wxuserInfo/" + item.queryPhone)
          .then(response => {
            loading.hide(function() {});
            if (response.data.success) {
              let targetUser = response.data.data;
              if (targetUser.paotuiStatus != 1) {
                weui.alert("该用户暂无跑腿资格");
              } else if (targetUser.worksite != this.userInfo.worksite._id) {
                weui.alert("TA不是本网点用户");
              } else {
                item.tempManagerId = targetUser._id;
                item.tempManagerName = targetUser.realname;
                item.tempManagerPhone = targetUser.phoneMain;
                item.tempQrimgBase64 = targetUser.headimgBase64;
                this.list = [...this.list];
              }
            } else {
              weui.alert(response.data.message);
            }
          })
          .catch(error => {
            loading.hide(function() {});
            weui.alert("获取用户信息失败");
          });
      }
    },
    delMaster(item) {
      weui.confirm(
        "确定删除？",
        () => {
          axios
            .delete("api/building/delExpressMaster/" + item._id)
            .then(res => {
              if (res.data.success) {
                weui.toast("设置成功");
                delete item.manager;
                this.list = [...this.list];
              } else {
                this.$message.error("删除楼长失败");
              }
            })
            .catch(err => {
              this.$message.error("删除楼长失败");
            });
        },
        function() {}
      );
    },
    set(item) {
      if (!item.tempManagerId) {
        weui.alert("请先查找楼长");
      } else {
        let loading = weui.loading("楼长设置中", {
          className: "custom-classname"
        });
        axios
          .put(
            "/api/building/setExpressMaster/" +
              item._id +
              "/" +
              item.tempManagerId
          )
          .then(res => {
            loading.hide(function() {});
            if (res.data.success) {
              weui.toast("设置成功");
              item.manager = {
                realname: item.tempManagerName,
                phoneMain: item.tempManagerPhone,
                headimgBase64: item.tempQrimgBase64
              }

              item.queryPhone = "";
              item.tempManagerId = "";
              item.tempManagerName = "";
              item.tempManagerPhone = "";
              item.tempQrimgBase64 = "";

              this.list = [...this.list];
            } else {
              weui.alert("设置失败");
            }
          })
          .catch(err => {
            loading.hide(function() {});
            weui.alert("设置失败");
          });
      }
    }
  }
};
</script>

<style scoped>
.robbing {
  font-size: 14px;
}
.robbing-nav {
  display: flex;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  text-align: center;
}
.robbing-nav-item {
  flex: 1;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  border-right: 1px solid #eee;
}
.robbing-nav-item:last-child {
  border-right: none;
}
.robbing-nav-item.select {
  color: red;
  border-bottom: 1px solid red;
}
.item {
  border: 1px solid #1aad19;
  margin: 15px;
}
.item + .item {
  margin-top: 10px;
}
.express-company {
  margin-top: 15px;
  font-size: 22px;
  font-weight: bold;
}
.express-count {
  color: orangered;
  font-weight: bold;
}
.img-container {
  margin-top: 10px;
  margin-bottom: 15px;
}
.img {
  width: 100px;
  height: 100px;
  border-radius: 100px;
}
.weui-footer {
  position: fixed;
  bottom: 10px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.weui-cells {
  margin-bottom: 10px;
}
.warehousing-footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  background-color: #1aad19;
  margin-top: 10px;
  line-height: 50px;
}
.warehousing-footer-item a {
  color: #ffffff;
}
.weui-cells_form .weui-cell__ft {
  font-size: 17px;
}
.mail-tips {
  font-size: 16px;
  text-align: left;
  padding: 10px;
  padding-left: 15px;
  background-color: lightyellow;
}
.delete-bnt {
  margin-left: 10px;
  background-color: red;
  color: #fff;
  padding: 0px 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/operations/SetBuildingManager.vue